import { DocumentsType } from 'v2-types/order';
import { DocumentFile } from '../types';

type SearchDocumentsParams = {
  documents: DocumentsType[],
  queryTokens?: string[],
  partyTokens?: string[],
  propertyTokens?: string[]
}

const replaceRegex = /[^a-zA-Z0-9 ]/g;
const replaceValue = '\\$&';
export const searchDocuments = ({
  documents,
  queryTokens,
  partyTokens,
  propertyTokens
}: SearchDocumentsParams) => {
  const regexSearchQuery = new RegExp(`(${queryTokens?.join('|')})`);
  const regexSearchParty = new RegExp(`${partyTokens?.join('|')}`);
  const regexSearchProperty = new RegExp(`${propertyTokens?.join('|')}`);

  const testRegexs = (text) => {
    if (queryTokens && regexSearchQuery.test(text)) return true;
    if (partyTokens && regexSearchParty.test(text)) return true;
    if (propertyTokens && regexSearchProperty.test(text)) return true;
    return false;
  };

  let filteredDocuments = documents.filter((document) => {
    const files = document.archives.flatMap((archive) => archive.files);
    const textArray: string[] = [
      document.description,
      document.kind,
      document.data.reduce((text, currentInvolvedParty) => {
        text
          += (currentInvolvedParty.name ?? '')
          + (currentInvolvedParty.address ?? '')
          + (currentInvolvedParty.kind ?? '');
        return text;
      }, ''),
      files.reduce((text, currentFile) => {
        text += currentFile.filename;
        return text;
      }, ''),
    ];

    if (queryTokens && regexSearchQuery.test(
      textArray
        .join()
        .toLowerCase()
        .replace(replaceRegex, replaceValue)
    )) {
      return true;
    }

    if (partyTokens && document.data.some((association) => regexSearchParty.test(association.name?.replace(/\s+/g, ' ').toLowerCase() ?? ''))) return true;
    if (propertyTokens && document.data.some((association) => regexSearchProperty.test(association.address?.toLowerCase() ?? ''))) return true;

    return false;
  });

  filteredDocuments = filteredDocuments.map((document) => {
    return ({
      ...document,
      archives: document.archives.map((archive) => {
        return archive;
      }),
      parts: document.parts?.filter((part) => {
        const filename = part.filename
          .toLowerCase()
          .replace(replaceRegex, replaceValue);
        return testRegexs(filename);
      }) ?? []
    });
  })
   ?? [];

  return filteredDocuments;
};

type SearchDocumentsFilesParams = {
  documents: DocumentFile[],
  queryTokens?: string[],
  partyTokens?: string[],
  propertyTokens?: string[]
}

export const searchDocumentsFiles = ({
  documents,
  queryTokens,
  partyTokens,
  propertyTokens
}: SearchDocumentsFilesParams) => {
  const regexSearchQuery = new RegExp(`(${queryTokens?.join('|')})`);
  const regexSearchParty = new RegExp(`${partyTokens?.join('|')}`);
  const regexSearchProperty = new RegExp(`${propertyTokens?.join('|')}`);

  const filteredDocuments = documents.filter((document) => {
    const textArray: string[] = [
      document.description,
      document.kind,
    ];

    if (document.data) {
      textArray.push(
        document.data.filter(({ kind }) => ["property", "party"].includes(kind)).reduce((text, currentInvolvedParty) => {
          text
          += (currentInvolvedParty.name ?? '')
          + (currentInvolvedParty.address ?? '')
          + (currentInvolvedParty.kind ?? '');
          return text;
        }, ''));
    }

    if (queryTokens && regexSearchQuery.test(
      textArray
        .join()
        .toLowerCase()
        .replace(replaceRegex, replaceValue)
    )) {
      return true;
    }

    if (partyTokens && document.data && document.data.some((association) => regexSearchParty.test(association.name?.replace(/\s+/g, ' ').toLowerCase() ?? ''))) return true;
    if (propertyTokens && document.data && document.data.some((association) => regexSearchProperty.test(association.address?.toLowerCase() ?? ''))) return true;

    return false;
  });
  return filteredDocuments;
};
